import { render, staticRenderFns } from "./locationInfo.vue?vue&type=template&id=8ded7234&scoped=true&"
import script from "./locationInfo.vue?vue&type=script&lang=js&"
export * from "./locationInfo.vue?vue&type=script&lang=js&"
import style0 from "./locationInfo.vue?vue&type=style&index=0&id=8ded7234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ded7234",
  null
  
)

export default component.exports